/* eslint-disable jsx-a11y/anchor-is-valid */
import UseSeason from 'app/modules/core/hooks/season/UseSeason'
import { FC, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'


const SeasonNotStartPage: FC = () => {
    const lastSeason = UseSeason()

    return (
        <> {lastSeason ? <Outlet /> : <div className={`card mb-5 mb-xl-8`}>
            {/* begin::Body */}
            <div className='card-body py-3' style={{ minHeight: '300px' }}>
                {/* begin::Table container */}
                <div className='pt-20'>
                    <h1 className='d-flex justify-content-center fw-bolder fs-4x text-gray-700 mb-10'>Season ยังไม่เปิด </h1>

                    <div className=' d-flex justify-content-center fw-bold fs-3 text-gray-400 mb-15'>
                        กรุณาติดต่อ admin
                    </div>
                </div>
                {/* end::Table container */}
            </div>
            {/* begin::Body */}
        </div>}

        </>
    )
}
export { SeasonNotStartPage }
